export const isIos = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};
